import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useContact(): RootState['contact'] {
    const contact = useSelector<RootState, RootState['contact']>(({ contact }) => contact)

    return contact
}
